import React from 'react';
import { Box, Text, Modal } from '@rsos/components/capstone/base';
import { ModalBody } from '@rsos/components/capstone/base/Modal/ModalComponents';
import Integrations from './Integrations/';
import FormSite from './Integrations/FormSite';
import {
  IntegrationManagementWrapper,
  Title,
  Subtitle,
  IMTitleContainer,
} from './Main.styles';

const Outbound = () => {
  const toggleIsModalVisible = () => {};
  const isModalVisible = false;
  return (
    <IntegrationManagementWrapper>
      <IMTitleContainer>
        <Title>Manage Integrations</Title>
        <Subtitle>for Outbound Data</Subtitle>
      </IMTitleContainer>
      <Box my={20} flow={10}>
        <Text size="normal" color="primaryText" inline>
          <Text size="normal" fontWeight="bold" color="primaryText" inline>
            Control what RapidSOS integration partners your ECC shares data with
          </Text>
          (eg: CAD, CPE/CHE, 911 equipment). Request, view, and test the
          credentials that integration partners need in order to access your
          ECC’s data.
        </Text>
        <Integrations />
        <Modal
          isOpened={isModalVisible}
          onClose={toggleIsModalVisible}
          width={850}
          id="modal-form-site"
        >
          <ModalBody onClose={toggleIsModalVisible}>
            <FormSite />
          </ModalBody>
        </Modal>
      </Box>
    </IntegrationManagementWrapper>
  );
};

export default Outbound;
